import { useMutation, useQuery } from '@tanstack/react-query';
import { getApplicationMetrics, getDbSlowQueries, getRedisCacheStatus, runDbExplain, testRedisCache } from './metricsApi';

export const createMetricsHooks = ({ queryClient }) => {
    const useApplicationMetrics = (options = {}) =>
        useQuery({
            queryKey: ['applicationMetrics'],
            queryFn: getApplicationMetrics,
            refetchInterval: options.refetchInterval ?? 60 * 1000,
        });

    const useRedisCacheStatus = (options = {}) =>
        useQuery({
            queryKey: ['redisCacheStatus'],
            queryFn: getRedisCacheStatus,
            refetchInterval: options.refetchInterval ?? 30 * 1000,
            refetchOnWindowFocus: false,
            retry: false,
        });

    const useTestRedisCache = () =>
        useMutation({
            mutationFn: testRedisCache,
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['redisCacheStatus'] });
                queryClient.invalidateQueries({ queryKey: ['applicationMetrics'] });
            },
        });

    const useDbSlowQueries = (options = {}) =>
        useQuery({
            queryKey: ['dbSlowQueries'],
            queryFn: getDbSlowQueries,
            refetchInterval: options.refetchInterval ?? 60 * 1000,
        });

    const useDbExplain = () =>
        useMutation({
            mutationFn: runDbExplain,
        });

    return {
        useApplicationMetrics,
        useRedisCacheStatus,
        useTestRedisCache,
        useDbSlowQueries,
        useDbExplain,
    };
};
